import React, { useEffect } from "react";

const BlogLayout = () => {
  // ✅ Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={styles.page}>
      {/* ===== Banner Section ===== */}
      <div style={styles.bannerSection}>
        <div style={styles.bannerOverlay}></div>
        <div style={styles.bannerContent}>
          <h1 style={styles.bannerTitle} className="slide-in">
            Automation in Business Processes
          </h1>
          <p style={styles.bannerText} className="slide-in">
            {/* Driving Efficiency,Accuracy,and Growth in Mechanical Industries */}
            Driving Efficiency,Accuracy and Growth 
          </p>
        </div>
      </div>

      {/* ===== Blog Container ===== */}
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>
            Automation in Business Processes: Transforming the Mechanical Industry
          </h1>

          {/* Author & Meta */}
          <div style={styles.meta}>
            <img
              src="./image/AI.png"
              alt="Author"
              style={styles.authorImage}
            />
            <div>
              <p style={styles.author}>By Jane Smith</p>
              <p style={styles.details}>
                <i className="far fa-calendar-alt" style={styles.iconInline}></i>{" "}
                23 Aug 2025 &nbsp; | &nbsp;
                <i className="far fa-clock" style={styles.iconInline}></i> 8 min
                read &nbsp; | &nbsp;
                <i className="far fa-eye" style={styles.iconInline}></i> 742
                Views
              </p>
            </div>
          </div>

          {/* Blog Intro */}
          <p style={styles.text}>
            <i className="fas fa-industry" style={styles.iconInline}></i>
            Automation is revolutionizing mechanical industries by streamlining
            repetitive tasks, reducing errors, and enhancing productivity. From
            assembly lines to predictive maintenance, businesses are adopting
            automation to improve efficiency and remain competitive in a rapidly
            evolving market.
          </p>
          <p style={styles.text}>
            <i className="fas fa-cogs" style={styles.iconInline}></i>
            Modern automation tools, such as robotic process automation (RPA),
            CNC machines, IoT-enabled systems, and AI-driven analytics, are
            playing a central role in reshaping mechanical business processes.
          </p>

          {/* Why Automation Matters */}
          <h2 style={styles.subheading}>Why Automation Matters in Mechanical Processes</h2>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-tachometer-alt" style={styles.iconList}></i>{" "}
              Increases production speed and efficiency
            </li>
            <li>
              <i className="fas fa-check-circle" style={styles.iconList}></i>{" "}
              Reduces human errors and ensures consistent quality
            </li>
            <li>
              <i className="fas fa-dollar-sign" style={styles.iconList}></i>{" "}
              Minimizes operational costs in the long run
            </li>
            <li>
              <i className="fas fa-shield-alt" style={styles.iconList}></i>{" "}
              Improves workplace safety by automating risky tasks
            </li>
          </ul>

          {/* Key Areas of Automation */}
          <h2 style={styles.subheading}>Key Areas of Automation in Mechanical Business</h2>
          <p style={styles.text}>
            <i className="fas fa-lightbulb" style={styles.iconInline}></i>
            Mechanical businesses are increasingly automating critical operations:
          </p>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-robot" style={styles.iconList}></i> Robotic
              arms in assembly lines
            </li>
            <li>
              <i className="fas fa-tools" style={styles.iconList}></i> CNC
              machining and automated fabrication
            </li>
            <li>
              <i className="fas fa-database" style={styles.iconList}></i>{" "}
              Predictive maintenance using IoT sensors
            </li>
            <li>
              <i className="fas fa-chart-line" style={styles.iconList}></i>{" "}
              AI-powered process monitoring and optimization
            </li>
          </ul>

          {/* Example: Automotive Industry */}
          <h2 style={styles.subheading}>Example: Automation in Automotive Manufacturing</h2>
          <p style={styles.text}>
            <i className="fas fa-car" style={styles.iconInline}></i>
            Automotive companies are leading adopters of automation. Robotic
            systems perform precision welding and painting, while automated
            guided vehicles (AGVs) handle material transport. These systems
            ensure faster production cycles, reduced defects, and safer working
            environments.
          </p>

          {/* Best Practices */}
          <h2 style={styles.subheading}>Best Practices for Successful Automation</h2>
          <p style={styles.text}>
            <i className="fas fa-clipboard-check" style={styles.iconInline}></i>
            To maximize the benefits of automation in mechanical industries,
            businesses should follow these practices:
          </p>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-users" style={styles.iconList}></i> Involve
              employees in automation planning
            </li>
            <li>
              <i className="fas fa-chalkboard-teacher" style={styles.iconList}></i>{" "}
              Provide training for new automated systems
            </li>
            <li>
              <i className="fas fa-sync-alt" style={styles.iconList}></i>{" "}
              Regularly update and maintain equipment
            </li>
            <li>
              <i className="fas fa-balance-scale" style={styles.iconList}></i>{" "}
              Balance automation with human expertise
            </li>
          </ul>

          {/* Future of Automation */}
          <h2 style={styles.subheading}>The Future of Automation in Mechanical Industries</h2>
          <p style={styles.text}>
            <i className="fas fa-rocket" style={styles.iconInline}></i>
            The future of automation lies in smart factories, where connected
            devices, real-time analytics, and autonomous robots create highly
            adaptive and efficient ecosystems. Businesses investing in Industry
            4.0 technologies will gain a significant competitive edge.
          </p>

          {/* Conclusion */}
          <h2 style={styles.subheading}>Conclusion</h2>
          <p style={styles.text}>
            <i className="fas fa-check-circle" style={styles.iconInline}></i>
            Automation in mechanical business processes is no longer optional—
            it’s a necessity for survival and growth. By adopting smart
            automation strategies, companies can enhance productivity, improve
            safety, and drive long-term profitability.
          </p>
        </div>
      </div>

      {/* ===== Animation CSS ===== */}
      <style>
        {`
          @keyframes slideIn {
            0% {
              opacity: 0;
              transform: translateX(-40px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }
          .slide-in {
            animation: slideIn 1.2s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  page: {
    position: "relative",
    background: "#fff",
    fontFamily: "Arial, sans-serif",
    letterSpacing: "0px",
  },
  /* ===== Banner Styles ===== */
  bannerSection: {
    position: "relative",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/automationinnusiness.webp')",  
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 10%",
    color: "#fff",
  },
  bannerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  bannerContent: {
    position: "relative",
    zIndex: 2,
    maxWidth: "600px",
  },
  bannerTitle: {
    fontSize: "42px",
    fontWeight: "bold",
    marginBottom: "15px",
    lineHeight: "1.3",
    letterSpacing:"0px",
    color:"white",
   
  },
  bannerText: {
    fontSize: "18px",
    lineHeight: "1.6",
    maxWidth: "500px",
    textAlign:"justify",
     wordSpacing:"0px",
  },

  /* ===== Blog Styles ===== */
  container: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
    maxWidth: "1200px",
    margin: "auto",
  },
  content: {
    flex: 1,
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "15px",
    lineHeight: "1.3",
    letterSpacing:"0px",
  },
  meta: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    gap: "12px",
  },
  authorImage: {
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  author: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "15px",
  },
  details: {
    margin: 0,
    fontSize: "14px",
    color: "#666",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#333",
    marginBottom: "15px",
    textAlign: "justify",
  },
  subheading: {
    fontSize: "22px",
    fontWeight: "600",
    marginTop: "25px",
    marginBottom: "12px",
    letterSpacing:"0px",
  },
  list: {
    paddingLeft: "0px",
    marginBottom: "20px",
    listStyle: "none",
  },
  iconList: {
    marginRight: "8px",
    color: "#007bff",
  },
  iconInline: {
    marginRight: "6px",
    color: "#007bff",
  },

  /* ===== Responsive ===== */
  "@media (max-width: 768px)": {
    bannerTitle: {
      fontSize: "28px",
    },
    bannerText: {
      fontSize: "16px",
    },
    title: {
      fontSize: "26px",
    },
  },
};

export default BlogLayout;
